import { render, staticRenderFns } from "./ReportCardErrorMessage.vue?vue&type=template&id=95ccd532"
import script from "./ReportCardErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ReportCardErrorMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports